<ngx-loading-bar [includeSpinner]="false" [color]="'#38c07e'" [height]="'2.5px'"></ngx-loading-bar>
<router-outlet></router-outlet>